import { Toaster as Sonner } from 'sonner';

export function Toaster() {
  return (
    <Sonner position="bottom-right" richColors closeButton
      toastOptions={{ className: 'font-sans', style: { fontSize: '14px' } }} />
  );
}
